/*
 * Copyright © 2016-2020 The Thingsboard Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import './silo-group-settings.scss';

/* eslint-disable import/no-unresolved, import/default */

import siloGroupSettingsTemplate from './silo-group-settings.tpl.html';

/* eslint-enable import/no-unresolved, import/default */

export default angular.module('agrolog.client.siloGroupSettings', [])
    .directive('agSiloGroupSettings', SiloGroupSettings)
    .name;

/*@ngInject*/
function SiloGroupSettings() {
    return {
        restrict: "E",
        scope: true,
        bindToController: {
            ctx: '='
        },
        controller: SiloGroupSettingsController,
        controllerAs: 'vm',
        templateUrl: siloGroupSettingsTemplate
    };
}

/* eslint-disable angular/angularelement */

/*@ngInject*/
function SiloGroupSettingsController($scope, $rootScope, $filter, $translate, types, agTypes, agUtils, assetService, attributeService, siloGroupService, userService) {

    let vm = this;

    vm.agTypes = agTypes;
    vm.show3DSettings = show3DSettings;
    vm.loading = false;

    vm.showData = userService.getAuthority() === 'TENANT_ADMIN' || userService.getAuthority() === 'CUSTOMER_USER';
    vm.siloGroupId = null;
    vm.siloGroup = null;
    vm.allowEditSettings = true;

    var user = userService.getCurrentUser();

    if (user.authority === 'CUSTOMER_USER') {
        var userAdditionalInfo = userService.getCurrentUserDetails().additionalInfo;
        if (userAdditionalInfo.readOnly) {
            vm.allowEditSettings = false;
        }
    }

    vm.helpPageAction = agUtils.createHelpActionConfig("agSiloGroup", "ag.docsPageSections.silo-group-settings");

    $scope.$watch('vm.ctx', function() {
        if (vm.ctx) {
            vm.ctx.widgetActions = [vm.helpPageAction];
            vm.ctx.hideTitlePanel = false;

            vm.siloGroupId = null;
            if (vm.ctx.stateController) {
                vm.siloGroupId = vm.ctx.stateController.getStateParams().entityId;
            }
            loadSiloGroup();
            $scope.$watch(function() {
                    return vm.ctx.stateController.getStateParams().entityId;
                },
                function (newSiloGroupId, prevSiloGroupId) {
                    if (newSiloGroupId && !angular.equals(newSiloGroupId, prevSiloGroupId)) {
                        vm.siloGroupId = newSiloGroupId;
                        loadSiloGroup();
                    }
                }
            );

        }
    });

    $scope.$watch(function() { return vm.siloGroup ? (vm.siloGroup.label || vm.siloGroup.name) : null; }, function(title) {
        if (vm.showData && vm.ctx && title) {
            vm.ctx.widgetTitle = $translate.instant('ag.silo-group.silo-group-settings') + ': ' + title;
        }
    });

    $scope.$on('$destroy', function() {
        reset();
    });

    $scope.$watch('vm.siloGroup.label', () => {
        if (vm.siloGroup && !$scope.theForm.$invalid) {
            assetService.saveAsset(vm.siloGroup).then(function success() {
                $rootScope.$broadcast('siteAssetUpdated', vm.siloGroup);
            });
        }
    });

    $scope.$watch('vm.siloGroup.coordinate3dX + vm.siloGroup.coordinate3dY + vm.siloGroup.coordinate3dZ + vm.siloGroup.viewrotation + vm.siloGroup.width + vm.siloGroup.height + vm.siloGroup.length', () => {
        if (vm.siloGroup && !$scope.theForm.$invalid) {
            var attributes = [];
            attributes.push({key: 'viewrotation', value: vm.siloGroup.viewrotation});
            attributes.push({key: 'width', value: vm.siloGroup.width});
            attributes.push({key: 'height', value: vm.siloGroup.height});
            attributes.push({key: 'length', value: vm.siloGroup.length});
            attributes.push({key: 'coordinate3dX', value: vm.siloGroup.coordinate3dX});
            attributes.push({key: 'coordinate3dY', value: vm.siloGroup.coordinate3dY});
            attributes.push({key: 'coordinate3dZ', value: vm.siloGroup.coordinate3dZ});
            attributeService.saveEntityAttributes(vm.siloGroup.id.entityType, vm.siloGroup.id.id,
                types.attributesScope.server.value, attributes)
                .then(function success() {});
        }
    });

    function loadSiloGroup() {
        vm.siloGroup = null;
        reset();
        if (vm.siloGroupId) {
            vm.loading = true;
            siloGroupService.getSiloGroup(vm.siloGroupId).then(
                function success(siloGroup) {
                    vm.siloGroup = siloGroup;
                    vm.loading = false;
                },
                function fail() {
                    vm.loading = false;
                }
            );
        }
    }

    function reset() {
    }

    function show3DSettings() {
        const siteParams = vm.ctx.stateController.getStateParamsByStateId(agTypes.clientState.site);

        if (userService.getAuthority() === 'CUSTOMER_USER') {
            return siteParams?.enable3D ?? false;
        }
        return true;
    }
}